module.exports = __webpack_public_path__ + "static/avatar-nate-62cf3edb09c8bc7eaca6a06f975cd130.png";